module.exports = {
    screens: {
        md: 450,
        lg: 1100
    }
};
